import React from 'react';
import { Box, Typography } from '@mui/material';

const listItemStyle = {
  marginBottom: '0.75rem',
};

const NodeMetricsSection = () => {
  return (
    <Box sx={{ px: { xs: 2, sm: 4 }, py: 2 }}>
      <Typography paragraph>
        The Node Metrics Page provides a visual and interactive display of monitoring data for specific IP and port combinations.
      </Typography>

      {/* Key Features */}
      <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
        Key Features
      </Typography>
      <ul style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}>
          <Typography variant="body1">
            <strong>Graphical Visualization:</strong> Displays real-time and historical performance metrics in chart format.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            <strong>IFrame Integration:</strong> The graphs are embedded directly within the page for uninterrupted analysis.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            <strong>Dynamic Content:</strong> Graphs are generated based on the IP and port the user selects from the Node Monitor Page.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            <strong>Responsive Design:</strong> Works seamlessly across different screen sizes and devices.
          </Typography>
        </li>
      </ul>

      {/* User Flow */}
      <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
        User Flow
      </Typography>
      <ol style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}>
          <Typography variant="body1">
            From the Node Monitor Page, click the View button on any entry.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            The Node Metrics Page loads graphs dynamically for the chosen IP and port.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            Users can explore trends and performance data through the graphs directly.
          </Typography>
        </li>
      </ol>
    </Box>
  );
};

export default NodeMetricsSection;
